"use client"

import { createContext, type ReactNode } from "react"
import type { PlatformScope } from "@/domain/scope/platform-scope"

/**
 * THE SLOT FOR A NON-BROKER SCOPE'S PAY-TO-ENTER WALL (spec multi-product 023
 * G55 (2); 018 P6, D37; 021 R-021-1; FIX-PLATFORM-SALE-GATE).
 *
 * `BillingGate` decides WHERE a non-broker `all-surfaces` scope's wall runs
 * (after the setup branch and the broker's request-time wall, before the
 * collections walls), but not HOW the firm's status is read: that read is
 * the shared settings Billing group's `getPaymentStatus`, the server's
 * sale-gated answer, and only a settings host binding may reach a section's
 * RPCs (R-021-1). The app mounts the host's wall here
 * (`PlatformScopePaymentWallProvider`); with nothing mounted the gate lets
 * the firm in (fail open), so a firm is never walled by a read it cannot make.
 */
export interface ScopePaymentWallProps {
  /** A non-broker scope whose derived wall covers every surface. */
  readonly surfaceScope: PlatformScope
  readonly isAdmin: boolean
  /** What the gate renders once the wall lets the firm in. */
  readonly children: ReactNode
}

/** Renders the host's wall around the gate's own view; a render function, so the gate never creates a component during render. */
export type RenderScopePaymentWall = (props: ScopePaymentWallProps) => ReactNode

export const ScopePaymentWallSlot = createContext<RenderScopePaymentWall | null>(null)
